import styled from "styled-components";

const FeelGoodFindInner = styled.div`
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;

  @media (max-width: 575px){
    margin-bottom: 25px;
  }
`;
export default FeelGoodFindInner;
